import AbsComponent from "../../common/AbsComponent";
import Templ from './CharacterInfoTempl';

/**
 * CharacterInfo class
 * @category main
 */
class CharacterInfo extends AbsComponent {
    constructor(_store = {}, _el = '') {
        super(_store, _el);

        if (this.store.getData('config').isLogin) {
            this.store.getData('CharacterInfo', {}, this.render.bind(this));
        }
    }

    render(_jsonData = {}) {
        // console.log('render CharacterInfo ----->', _jsonData);
        this.data = _jsonData.data;

        $(this.el).append(Templ.getTempl(_jsonData));

        this.setting();
        this.addEvents();
    }

    setting() {

        const slickOption = {
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 4000,
                    settings: "unslick"
                },
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
            ]
        };

        $(this.el + ' .character-info-list').slick(slickOption);

        window.addEventListener("resize", ()=>{
            if(window.innerWidth < 960 && $(this.el + ' .character-info-list').slick('getSlick').unslicked) {
                $(this.el + ' .character-info-list').slick(slickOption);
            }
        });
    }

    addEvents() {
        this.salesProgressBtn = $('#charInfoSales button[data-status="progress"]');
        this.salesCompleteBtn = $('#charInfoSales button[data-status="complete"]');
        this.nowSalesSelectTab = 1;

        this.salesProgressBtn.on('click', (e)=>{
            if( this.nowSalesSelectTab === 1 ){
                return false;
            }
            this.salesProgressBtn.addClass('is-active');
            this.salesCompleteBtn.removeClass('is-active');
            this.nowSalesSelectTab = 1;

            const salesList = Templ.salesItemList(this.data.commissions.onSales, 1);
            $('#charInfoSales ul').html( salesList );
        });

        this.salesCompleteBtn.on('click', (e)=>{
            if( this.nowSalesSelectTab === 2){
                return false;
            }
            this.salesProgressBtn.removeClass('is-active');
            this.salesCompleteBtn.addClass('is-active');
            this.nowSalesSelectTab = 2;

            const salesList = Templ.salesItemList(this.data.commissions.notOnSales, 2);
            $('#charInfoSales ul').html( salesList );
        });


        $(this.el + ' .character-info-notice a.notice-link').on('click', (e)=>{
            if( typeof cnb.openCharacterPan === 'function' ){
                cnb.openCharacterPan();
            }
        });
    }

} // end of class
export default CharacterInfo;